module.exports = __webpack_public_path__ + "static/javascript-08ed2702b42e0c92a4a88da0b2872fcf.png";